import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { Widget, WidgetPages } from '@xsolla/login-sdk';

import { Fields } from './CustomAskField/types';
import { FieldPreviewWrapper, WidgetFrame } from './style';

type Props = {
  projectId: string;
  fields?: string[];
  fieldsData: Fields;
};

export const FieldsPreviewFrame = ({ projectId, fields, fieldsData }: Props): JSX.Element => {
  const [currentHeight, setCurrentHeight] = useState<number>(780);
  const widgetContainerRef = useRef<HTMLDivElement>(null);
  const { locale } = useIntl();

  useEffect(() => {
    if (!fields) {
      return;
    }

    if (widgetContainerRef && widgetContainerRef.current) {
      widgetContainerRef.current.innerHTML = '';
    }

    // ToDo: get this settings from "Current project" context or mock them, so widget is always in Classic mode?
    const newSettings = {
      authorization_methods: ['email', 'social'],
      can_register: true,
      can_reset_password: true,
      consent_url: null,
      cookie_policy: null,
      data_controller: 'partner',
      email_validation: { use_xsolla_email_validator: false },
      game_name: '',
      one_tap_login: {},
      privacy_policy: null,
      registration_fields: [
        { name: 'email', required: true, type: 'email', validation: {} },
        { name: 'password', required: true, type: 'pass', validation: {} }
      ],
      tos_url: null
    };

    newSettings.registration_fields.push(
      ...Object.values(fieldsData).map(({ is_required, ...field }) => {
        return {
          ...field,
          required: is_required,
          validation: {}
        };
      })
    );

    const widget = new Widget({
      projectId,
      url: process.env.LOGIN_WIDGET_URL || 'https://login-widget.xsolla.com/latest',
      preferredLocale: locale === 'zh' ? 'zh_CN' : `${locale}_XX`,
      disableCache: true,
      page: WidgetPages.SignUpPage,
      // ToDo: uncomment when widget can take settings as JS Object
      // settingsJSON: JSON.stringify(newSettings),
      isDemo: true
    });
    widget.mount('widget_container');

    setCurrentHeight(780 + fields.length * 70);
  }, [fields]);

  return (
    <FieldPreviewWrapper>
      <WidgetFrame ref={widgetContainerRef} height={currentHeight} id="widget_container" />
    </FieldPreviewWrapper>
  );
};
